import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Button, Stack, Tab } from '@mui/material'
import FloorImageMap from 'components/Event/FloorImageMap'
import { CheckPoint, Floor } from 'interface'
import { SyntheticEvent, useState } from 'react'

interface IProps {
  floors: Floor[]
  curPoint?: CheckPoint
  positions: CheckPoint[]
  canEdit?: boolean
  useEdit?: () => void
  addPosition?: (val: { lat: number; lng: number }) => void
  updatePosition?: (val: { lat: number; lng: number }) => void
  released?: boolean
}
export default function FloorMap({
  floors = [],
  curPoint,
  positions,
  canEdit,
  useEdit,
  addPosition,
  updatePosition,
  released,
}: IProps) {
  const [floor, setFloor] = useState(() => {
    if (curPoint) return Math.round(curPoint.lat / 1000).toString()
    else return floors[0].id.toString()
  })
  const [updatePoint, setUpdatePoint] = useState<{
    lat: number
    lng: number
  }>()
  const handleChange = (_event: SyntheticEvent, newValue: string) => {
    setFloor(newValue)
  }
  return (
    <Box
      sx={{
        p: 2,
        boxShadow: '0px 0px 20px rgba(0,0,0,0.2),0 0 10px rgba(0,0,0,0.1)',
      }}
    >
      <TabContext value={floor}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              width: '100%',
            }}
          >
            {floors.map((f, i) => {
              return <Tab key={i} label={f.floorName} value={f.id.toString()} />
            })}
          </TabList>
        </Box>
        <Box sx={{ width: '100%' }}>
          {floors.map((f, i) => {
            return (
              <TabPanel key={f.id} value={f.id.toString()}>
                {floor === f.id.toString() && (
                  <FloorImageMap
                    floor={f}
                    canEdit={canEdit}
                    positions={positions
                      .filter((p) => Math.round(p.lat / 1000) === f.id)
                      .filter((p) => !canEdit || p.id !== curPoint?.id)
                      .map((v) => ({
                        x: v.lat % 1000,
                        y: v.lng % 1000,
                      }))}
                    initPoint={
                      !canEdit
                        ? curPoint && {
                            x: curPoint.lat % 1000,
                            y: curPoint.lng % 1000,
                          }
                        : undefined
                    }
                    setPosition={({ lat, lng }) => {
                      if (!canEdit) {
                        addPosition &&
                          addPosition({
                            lat: f.id * 1000 + lat,
                            lng: f.id * 1000 + lng,
                          })
                      } else {
                        setUpdatePoint({
                          lat: f.id * 1000 + lat,
                          lng: f.id * 1000 + lng,
                        })
                      }
                    }}
                  />
                )}
              </TabPanel>
            )
          })}
        </Box>
      </TabContext>
      {!released ? (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          {!canEdit && useEdit ? (
            <Button color="info" variant="contained" onClick={useEdit}>
              修正する
            </Button>
          ) : (
            curPoint && (
              <Button color="warning" variant="outlined" onClick={useEdit}>
                キャンセル
              </Button>
            )
          )}
          {canEdit && updatePosition && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                updatePoint && updatePosition && updatePosition(updatePoint)
              }}
            >
              決定する
            </Button>
          )}
        </Stack>
      ) : (
        ''
      )}
    </Box>
  )
}
